import Vue from 'vue';
import Modificadores from '../../clases/Modificadores.js'
const BIG_STATIC_COLLECTIONS = [
  'PDV_Productos', 'PDV_Clientes', 'PDV_Ventas', 'PDV_Inventario',
  'MBS_Membresias', 'MBS_Membresias_Coleccion', 'AYB_Mapas',
  'BIO_CheckIn', 'AYB_Contenedores'
];

function optimizeReactivity(listName, item) {
  if (BIG_STATIC_COLLECTIONS.includes(listName) && item && typeof item === 'object') {
    // Evita que Vue aplique recursivamente getters/setters (Reactividad Profunda)
    if (!Object.hasOwn(item, '_isVue')) {
      Object.defineProperty(item, '_isVue', { value: true, configurable: false, enumerable: false, writable: true });
    }
  }
  return item;
}

const indexMapCache = new WeakMap();

function getFastIndex(list, id) {
  if (!Array.isArray(list)) return -1;
  let cache = indexMapCache.get(list);

  if (!cache) {
    cache = new Map();
    const len = list.length;
    for (let i = 0; i < len; i++) {
      if (list[i] && list[i].id !== undefined) cache.set(list[i].id, i);
    }
    indexMapCache.set(list, cache);
  }

  if (cache.has(id)) {
    const idx = cache.get(id);
    if (list[idx] && list[idx].id === id) return idx;
  }

  const realIdx = list.findIndex(el => el && el.id === id);
  if (realIdx !== -1) {
    cache.set(id, realIdx);
  } else {
    cache.delete(id);
  }
  return realIdx;
}

function updateFastIndex(list, id, newIndex) {
  const cache = indexMapCache.get(list);
  if (cache) cache.set(id, newIndex);
}

function removeFastIndex(list, id) {
  const cache = indexMapCache.get(list);
  if (cache) cache.delete(id);
}
export default {
  namespaced: true,
  state: () => ({
    sessions: {},
    signIns_lastSuccess: {},
    signIns_offline: {},
    RVA_Catalogo: {},
    RVA_Departamentos: [],
    Ids_Departamentos: {},
    RVA_Mayoristas_Coleccion: [],
    PDV_Productos: [],
    PDV_Clientes: [],
    PDV_Inventario: [],
    PDV_Inventario_Origenes: [],
    PDV_Departamentos: [],
    PDV_TipoCambio: [],
    PDV_Monedas_Lista: [],
    PDV_Pagos_Tipos: [],
    PDV_Productos_Categorias: [],
    PDV_Promociones: [],
    MBS_Membresias: [],
    MBS_Planes: [],
    MBS_Beneficios: [],
    MBS_Periodos: [],
    BNK_LineasCredito: [],
    PDV_Modificadores: [],
    RVA_Tarifas: [],
  }),
  getters: {
    getRVATarifas: state => {
      return state.RVA_Tarifas;
    },
    getModificadores(state) {
      let Modi = [];
      state.PDV_Modificadores.forEach((item) => {
        Modi.push(new Modificadores(item));
      })
      return Modi;
    },
    getMbsMembresias: state => {
      return state.MBS_Membresias;
    },
    getMbsBeneficios: state => {
      return state.MBS_Beneficios;
    },
    getMbsPlanes: state => {
      return state.MBS_Planes;
    },
    getMbsPeriodos: state => {
      return state.MBS_Periodos;
    },
    getBNK_LineasCredito: state => {
      let linea = state.BNK_LineasCredito;
      let lc = [];
      linea.forEach(lineasCredito => {
        if (lineasCredito.Activo) {
          lc.push(lineasCredito);
        }
      })
      return lc;
    }
  },
  mutations: {
    setLoader(state, data) {
      state[data.loader] = data.value
    },
    setNewOrder(state, data) {
      state.newActionPreorder = data
    },
    unSetData(state, data) {
      state[data] = [];
    },
    /**
     * Se usa para llenar las listas en vuex con toda la información obtenida de indexeddb
     * @param  {vuex} state default
     * @param  {object} data objeto con la información para agregar
     *  data.items - Registros obtenidos
     *  data.list - Nombre de lista donde se agregarán los registros
     */
    setAllItems(state, data) {
      if (data.items) {
        let itemsToSet = data.items;
        if (Array.isArray(itemsToSet)) {
          itemsToSet.forEach(item => optimizeReactivity(data.list, item));
        }

        Vue.set(
          state,
          data.list,
          itemsToSet
        );
      }
    },
    /**
     * Agrega o actualiza un registro a las listas de tipo Array
     * @param  {vuex} state default
     * @param  {object} data objeto con la información para agregar
     *  data.list - Nombre de lista a agregar
     *  data.id - Identificador del registro a agregar
     *  data.element - Registro a agregar
     */
    async setArrayItem(state, data) {
      const foundedIndex = getFastIndex(state[data.list], data.id);
      data.element.id = data.id;
      if (data.enableMerge) {
        const exist = await Vue.prototype.$dbHandler.getRecord(data.list, data.id);
        data.element = {
          ...exist,
          ...data.element
        }
      }
      optimizeReactivity(data.list, data.element);
      if (data.onlyVuex) {
        if (foundedIndex > -1) {
          Vue.set(
            state[data.list],
            foundedIndex,
            data.element
          );
          if (data.forceUpdate) {
            state[data.list].push(data.element);
            updateFastIndex(state[data.list], data.id, state[data.list].length - 1);
          }
        } else {
          state[data.list].push(data.element);
          updateFastIndex(state[data.list], data.id, state[data.list].length - 1);
        }
      } else {
        Vue.prototype.$dbHandler
          .putRecord(data.list, data.element)
          .then(() => {
            if (foundedIndex > -1) {
              Vue.set(
                state[data.list],
                foundedIndex,
                data.element
              );
              if (data.forceUpdate) {
                state[data.list].push(data.element);
                updateFastIndex(state[data.list], data.id, state[data.list].length - 1);
              }
            } else {
              state[data.list].push(data.element);
              updateFastIndex(state[data.list], data.id, state[data.list].length - 1);
            }
          })
          .catch((err) => { });
      }
    },
    /**
     * Agrega o actualiza múltiples registros a las listas de tipo Array de forma atómica.
     * Optimizado para reducir la carga de CPU y la reactividad de Vue 2.
     */
    async setArrayItems(state, data) {
      if (!Array.isArray(data.elements) || data.elements.length === 0) return;

      const listName = data.list;
      const currentList = state[listName] || [];

      // OPTIMIZACIÓN: Trabajamos sobre una copia local para mutar de un solo golpe (Single-Hit Reactivity)
      const newList = [...currentList];

      // Obtener o inicializar el mapa de índices de alto rendimiento
      // Si el cache existe, lo clonamos para actualizarlo junto con newList
      const existingCache = indexMapCache.get(currentList);
      const tempCache = existingCache ? new Map(existingCache) : new Map();

      // Si no hay cache previo en un arreglo grande, lo construimos una vez
      if (!existingCache && newList.length > 0) {
        newList.forEach((item, index) => {
          if (item && item.id !== undefined) tempCache.set(item.id, index);
        });
      }

      const elementsToSave = [];

      data.elements.forEach((item) => {
        // Normalización básica de ID
        const rawId = item.id || item.Id || (item.document ? item.data().id : null);
        if (rawId === null || rawId === undefined) return;

        const element = optimizeReactivity(listName, { ...item, id: rawId, Id: rawId });
        elementsToSave.push(element);

        // Búsqueda O(1) usando el cache
        let foundedIndex = tempCache.has(rawId) ? tempCache.get(rawId) : -1;

        // Verificación de seguridad por si el arreglo cambió externamente
        if (foundedIndex > -1 && (!newList[foundedIndex] || newList[foundedIndex].id !== rawId)) {
          foundedIndex = newList.findIndex(el => el && el.id === rawId);
        }

        if (foundedIndex > -1) {
          newList[foundedIndex] = element;
        } else {
          newList.push(element);
          tempCache.set(rawId, newList.length - 1);
        }
      });

      // 1. Sincronía con IndexedDB (Operación en bloque)
      if (!data.onlyVuex) {
        Vue.prototype.$dbHandler
          .putRecords(listName, elementsToSave)
          .catch(err => console.error(`Error BD [${listName}]:`, err));
      }

      // 2. Sincronía con Vuex (UN SOLO TRIGGER DE REACTIVIDAD)
      Vue.set(state, listName, newList);

      // 3. Persistir el cache para la próxima operación O(1)
      indexMapCache.set(newList, tempCache);
    },
    /**
     * Agrega o actualiza un registro a las listas de tipo Object
     * @param  {vuex} state default
     * @param  {object} data objeto con la información para agregar
     *  data.id - Identificador del registro a agregar
     *  data.element - Registro a agregar
     *  data.list - Nombre de lista a agregar
     * data.key - Key para acceder al objeto (puede o no ser el mismo que el id)
     */
    setObjectItem(state, data) {
      const toSave = { id: data.id, ...data.element };

      Vue.prototype.$dbHandler
        .putRecord(data.list, toSave)
        .then(() => {
          Vue.set(
            state[data.list],
            data.key,
            toSave
          );
        })
        .catch((err) => { });
    },
    /**
     * Agrega un registro a las listas de tipo Array que se usan comportan como colas (Solamente la lista de llamadas pendientes por ahora 04/2021)
     * @param  {vuex} state default
     * @param  {object} data objeto con la información para agregar
     *  data.element - Registro a agregar
     *  data.list - Nombre de lista a agregar
     */
    addArrayItem(state, data) {
      Vue.prototype.$dbHandler
        .addRecord(data.list, data.element)
        .then(() => {
          state[data.list].push(data.element);
        })
        .catch((err) => { });
    },
    /**
     * Elimina un registro de las listas de tipo Array
     * @param  {vuex} state default
     * @param  {object} data objeto con la información para agregar
     *  data.list - Nombre de lista
     *  data.id - Identificador del registro a borrar
     */
    unsetArrayItem(state, data) {
      const foundedIndex = getFastIndex(state[data.list], data.id);
      if (foundedIndex > -1) {
        if (data.onlyVuex) {
          Vue.delete(state[data.list], foundedIndex);
          removeFastIndex(state[data.list], data.id);
        } else {
          Vue.prototype.$dbHandler
            .deleteRecord(data.list, data.id)
            .then(() => {
              Vue.delete(state[data.list], foundedIndex);
              removeFastIndex(state[data.list], data.id);
            })
            .catch((err) => { });
        }
      }
    },
    /**
     * Elimina múltiples registros de las listas de tipo Array de forma atómica.
     * Optimizado para reducir la carga de CPU y la reactividad de Vue 2.
     */
    unsetArrayItems(state, data) {
      if (!Array.isArray(data.ids) || data.ids.length === 0) return;

      const listName = data.list;
      const currentList = state[listName] || [];
      const idsToRemove = new Set(data.ids);

      // OPTIMIZACIÓN: Filtrar todo el arreglo en una sola pasada O(N)
      // En lugar de hacer N splices de O(N) cada uno (resultando en O(N^2))
      const newList = currentList.filter(item => item && !idsToRemove.has(item.id));

      if (!data.onlyVuex) {
        Vue.prototype.$dbHandler
          .deleteRecords(listName, data.ids)
          .catch(err => console.error(`Error BD Delete [${listName}]:`, err));
      }

      // Reemplazo atómico de estado (UN SOLO TRIGGER DE REACTIVIDAD)
      Vue.set(state, listName, newList);

      // Invalidar cache para que se reconstruya correctamente en la siguiente consulta
      indexMapCache.delete(currentList);
      indexMapCache.delete(newList);
    },
    /**
     * Elimina un registro de las listas de tipo Object
     * @param  {vuex} state default
     * @param  {object} data objeto con la información para agregar
     *  data.list - Nombre de lista
     *  data.id - Key del registro a borrar
     */
    unsetObjectItem(state, data) {
      Vue.prototype.$dbHandler
        .deleteRecord(data.list, data.id)
        .then(() => {
          Vue.delete(state[data.list], data.id);
        })
        .catch((err) => { });
    },
  },
  actions: {}
}
